import * as React from "react";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { MagnifyingGlass as SearchIcon } from "@phosphor-icons/react/MagnifyingGlass";
import { X as ClearIcon } from "@phosphor-icons/react/X";

export interface DebouncedSearchBarProps {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	delayMs?: number;
}

export function DebouncedSearchBar({
	value,
	onChange,
	placeholder = "Search accounts",
	delayMs = 250,
}: DebouncedSearchBarProps): React.JSX.Element {
	const [local, setLocal] = React.useState(value);

	React.useEffect(() => {
		setLocal(value);
	}, [value]);

	React.useEffect(() => {
		if (local === value) return;
		const t = setTimeout(() => onChange(local), delayMs);
		return () => clearTimeout(t);
	}, [local, value, onChange, delayMs]);

	return (
		<TextField
			size="small"
			fullWidth
			value={local}
			onChange={(e) => setLocal(e.target.value)}
			placeholder={placeholder}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<SearchIcon size={18} />
					</InputAdornment>
				),
				endAdornment: local ? (
					<InputAdornment position="end">
						<IconButton
							size="small"
							onClick={() => setLocal("")}
							edge="end">
							<ClearIcon size={16} />
						</IconButton>
					</InputAdornment>
				) : undefined,
			}}
		/>
	);
}
